import { Injectable } from '@angular/core';
import { lastValueFrom, take } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { PopUpAd } from '../models/pop-ad.type';

@Injectable({
  providedIn: 'root',
})
export class AdsService {
  constructor(private http: HttpClient) {}

  getPopAd(): Promise<PopUpAd | null> {
    return lastValueFrom<any>(
      this.http.get(`${environment.apiUrl}/pop-up-ads/one`).pipe(take(1))
    );
  }

  popupAdAnalytics(data: {
    adId: number;
    durationInSeconds: number;
  }): Promise<PopUpAd | null> {
    return lastValueFrom<any>(
      this.http
        .post(
          `${environment.apiUrl}/pop-up-ad-analytics`,
          {
            adId: data.adId,
            durationInSeconds: data.durationInSeconds,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .pipe(take(1))
    );
  }
}
